export const LOGGER_URL = '/api/v1/front-events';

export const PROD_HOSTNAME = 'jewelry.krastsvetmet.ru';
